// extracted by mini-css-extract-plugin
export default {"table":"omDWnwPGRxVcn9Mq4UHw"};